var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState, createRef, useEffect, useMemo, useRef } from 'react';
import clsx from 'clsx';
import Button from '../Button/Button';
import useStyles from '../ProductDetailPurchase/ProductDetailPurchase.styles';
import * as Yup from 'yup';
import DayPicker from '../DayPicker/DayPicker';
import { default as TextField } from '../TextField/TextField';
import addDays from 'date-fns/addDays';
import isBefore from 'date-fns/isBefore';
import DeliveryOptions from '../DeliveryOptions/DeliveryOptions';
import { FormikContext } from 'formik';
import { default as _get } from 'lodash/get';
import { default as _pick } from 'lodash/pick';
import { isEmpty } from 'lodash';
import format from 'date-fns/format';
import DeliveryInstructions from '../DeliveryInstructions/DeliveryInstructions';
import GiftUnavailableModal from '../GiftUnavailableModal/GiftUnavailableModal';
import DateSearchModal from '../DateSearchModal/DateSearchModal';
import DeliveryPassLoginPrompt from '../DeliveryPassLoginPrompt/DeliveryPassLoginPrompt';
import Modal from '../Modal/Modal';
import SignInModal from '../SignInModal/SignInModal';
import { useTheme, Box } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import { SiteContext, errorMessages, inputValidationRegex, convertDateFormat, isIpad, formatTime, getCollectionDay, } from '../../utils/common';
import ChooseDeliveryPass from '../ChooseDeliveryPass/ChooseDeliveryPass';
import { isSameDay, isValid, lastDayOfMonth } from 'date-fns';
import DeliveryUnavailableModal from '../DeliveryUnavailableModal/DeliveryUnavailableModal';
import qs from 'qs';
import { useRouter } from 'next/router';
import ProductAvailabileDayPicker from '../DayPicker/ProductAvailabileDayPicker';
import { default as formatDate } from 'date-fns/format';
import addMonths from 'date-fns/addMonths';
import { useSessionStorage } from '../../utils/utilityCustomHooks';
import Link from '../Link/Link';
import { DELIVERY_INSTRUCTION_LINK, DAYPICKER_ERROR_MESSAGE } from '../../utils/constants';
const AddressLine = ({ children, isTabletAndBelow, }) => (isTabletAndBelow && children ? _jsx("div", { children: children }) : _jsx("span", { children: children }));
const CollectionDetails = ({ currentChosenCcDetails, deliveryDate, isTabletAndBelow, classes = {}, }) => {
    const { name, addLine2, town, countyName, postCode, openingTime, closingTime } = currentChosenCcDetails || {};
    return (_jsxs(_Fragment, { children: [deliveryDate && _jsx("div", { children: format(convertDateFormat(deliveryDate), 'EEEE do MMMM') }), _jsx("div", { className: isTabletAndBelow ? classes.collectionTitle : '', children: isTabletAndBelow ? 'Collection From:' : 'Collect from florist' }), name && _jsx("div", { className: !isTabletAndBelow ? classes.collectionTitle : '', children: name }), addLine2 && _jsx(AddressLine, { isTabletAndBelow: isTabletAndBelow, children: `${addLine2}, ` }), town && _jsx(AddressLine, { isTabletAndBelow: isTabletAndBelow, children: `${town}, ` }), countyName && _jsx(AddressLine, { isTabletAndBelow: isTabletAndBelow, children: `${countyName} ` }), postCode && _jsx(AddressLine, { isTabletAndBelow: isTabletAndBelow, children: postCode }), openingTime && closingTime && deliveryDate && (_jsx("div", { className: classes.collectionTime, children: `${getCollectionDay(deliveryDate)} ${formatTime(openingTime)} - ${formatTime(closingTime)}` }))] }));
};
export const validationConfig = Yup.object().shape({
    deliveryDate: Yup.string().required('Please enter a delivery date'),
    deliveryInstructionNote: Yup.string().matches(inputValidationRegex, errorMessages().unsupportedCharacters),
});
export const initialValues = {
    deliveryDate: '',
    deliveryOptions: [],
    deliveryInstructionOption: '',
    deliveryInstructionNote: '',
};
const PurchaseDate = ({ step, currentStep, setCurrentStep, sameDay, isProductFulfillableCallback, handleDeliveryOptionsCall, variant, productAvailabilityCallback, handleCancelChanges, selectedServiceDescription, productKey, occasion, onSignIn, digitalProducts, hasActiveDeliveryPass, deliveryDate: initialDeliveryDate, productAvailability: initialProductAvailablity, initialDeliveryOptions, isUpdateDate, isDropship, isFuneral, isInternational, deliveryOptionsInfo, handleDeliveryOptionsOrAlternateProducts, isFromBasketUpdate, handleBasketLineItem, sendDateAnalytics, isFromTributeUpdate, oldCalendar, saveUserJourneyAnalytics, handleCCProductAvailability, sendDeliveryOptionAnalytics, sendClickAndCollectStatusAnalytics, collectionOptions, sendClickAndCollectMapOrListViewAnalytics, sendClickAndCollectLoadMoreAnalytics, sendClickAndCollectCloseModalAnalytics, sendClickAndCollectSelectFloristAnalytics, sendClickAndCollectStartNewSearchAnalytics, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const formikContext = useContext(FormikContext);
    const [requestError, setRequestError] = useState();
    const [isUnavailableModalOpen, setUnavailableModalOpen] = useState(false);
    const [isPorductsUnavailableModalOpen, setIsProductUnavailableModalOpen] = useState(false);
    const [unavailableProductsCount, setUnavailablePorductsCount] = useState(0);
    const [isChooseAnotherDate, setIsChooseAnotherDate] = useState(false);
    const [suggesProducts, setSuggesProducts] = useState();
    const [isDateSearchOpen, setDateSearchOpen] = useState(false);
    const [openSignInModal, setSignInModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChangeDeliveryDate, setIsChangeDeliveryDate] = useState(false);
    const [isDateChange, setIsDateChange] = useState(false);
    const [noProductAvalible, setNoProductAvalible] = useState(false);
    const [showProductAvailableCalendar, setShowProductAvailableCalendar] = useState(false);
    const [fromChooseDateOnUnavailModal, setFromChooseDateOnUnavailModal] = useState(false);
    const [ccProductAvailabilityResponse, setCcProductAvailabilityResponse] = useState();
    const [currentChosenCcDetails, setCurrentChosenCcDetails] = useState();
    const [initialFirstDate, setInitialFirstDate] = useState();
    const stepRef = createRef();
    const { getCustomer, isFlyingFlowers } = useContext(SiteContext);
    const theme = useTheme();
    const { classes } = useStyles();
    const isMobile = !useMediaQuery({ query: `(min-width: ${theme.breakpoints.values.sm}px)` });
    const isTabletAndBelow = useMediaQuery({ query: `(max-width: ${theme.breakpoints.values.md}px)` });
    const router = useRouter();
    const prevStepRef = useRef();
    const prevAddressRef = useRef();
    const [showDeliveryInstruction, setShowDeliveryInstruction] = useState(false);
    const { saveToSessionStorage } = useSessionStorage();
    const { productAvailability: productAvailabilityFormik, deliveryDate: deliveryDateFormik, deliveryOptions: formikDeliveryOptions, isCalendarPicked, selectedDeliveryOptionIndex, addressLine1, addressLine2, addressLine3, city, county, postalCode, country, deliveryInstructionOption, deliveryInstructionNote, deliveryPassSku, isCalendarOpen, productName, occasion: formikOccasion, } = formikContext.values;
    const [deliveryOptions, setDeliveryOptions] = useState(formikDeliveryOptions || initialDeliveryOptions);
    const [selectedDeliveryOption, setSelectedDeliveryOption] = useState('');
    const productAvailability = productAvailabilityFormik || initialProductAvailablity || [];
    const deliveryDate = deliveryDateFormik || initialDeliveryDate;
    const validDeliveryDate = (productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.some((availableDate) => availableDate.date === deliveryDate)) ||
        (initialProductAvailablity === null || initialProductAvailablity === void 0 ? void 0 : initialProductAvailablity.some((availableDate) => availableDate.date === deliveryDate));
    const validDeliveryOption = useMemo(() => deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.some((deliveryOption) => deliveryOption.title === selectedServiceDescription || deliveryOption.title === selectedDeliveryOption), [deliveryOptions, selectedDeliveryOption, selectedServiceDescription]);
    const [validDelivery, setValidDeliveryDate] = useState(false);
    const formikAddress = {
        addressLine1,
        addressLine2,
        addressLine3,
        city,
        county,
        postalCode,
        country,
    };
    const [purchaseDateError, setPurchaseDateError] = useState('');
    useEffect(() => {
        if (currentStep < step) {
            setPurchaseDateError('');
        }
    }, [currentStep, step]);
    useEffect(() => {
        setValidDeliveryDate(productKey && validDeliveryDate && validDeliveryOption);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validDeliveryDate, validDeliveryOption]);
    const getRuleIds = (date) => {
        var _a;
        return _get(((_a = formikContext.values.productAvailability) === null || _a === void 0 ? void 0 : _a.filter((day) => day.date === date)[0]) ||
            (productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.filter((day) => day.date === date)[0]), 'deliveryServiceTypes', []).map((serviceType) => serviceType.ruleId);
    };
    const getCCProductAvailability = (deliveryDate, country, formikAddress, shouldUseCurrentSelectedCCAddress) => __awaiter(void 0, void 0, void 0, function* () {
        var _m, _o;
        //handling Click and Collect delivery option
        if (handleCCProductAvailability &&
            ((_o = (_m = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values) === null || _m === void 0 ? void 0 : _m.ccAvailability) === null || _o === void 0 ? void 0 : _o.find((obj) => obj.date === deliveryDate))) {
            const response = yield handleCCProductAvailability(deliveryDate, country, formikAddress);
            setCcProductAvailabilityResponse(response);
            if (Array.isArray(response) && response.length && !shouldUseCurrentSelectedCCAddress) {
                setCurrentChosenCcDetails(response[0]);
            }
        }
    });
    const getDeliveryOptionsOrAlaternateProducts = (shouldUseCurrentSelectedCCAddress) => __awaiter(void 0, void 0, void 0, function* () {
        var _p, _q;
        setIsProductUnavailableModalOpen(false);
        setSuggesProducts([]);
        setUnavailablePorductsCount(0);
        setCcProductAvailabilityResponse([]);
        const ruleIds = getRuleIds(deliveryDate);
        setIsSubmitting(true);
        const { country, occasion } = _pick(formikContext.values, ['country', 'occasion']);
        if (handleDeliveryOptionsOrAlternateProducts) {
            try {
                const [response] = yield Promise.all([
                    handleDeliveryOptionsOrAlternateProducts(deliveryDate, ruleIds, deliveryPassType, country, formikAddress, occasion),
                    getCCProductAvailability(deliveryDate, country, formikAddress, shouldUseCurrentSelectedCCAddress),
                ]);
                if (response.error) {
                    setRequestError(`The availability check returned an error response: ${response.error}`);
                }
                if ((_p = response === null || response === void 0 ? void 0 : response.deliveryOptions) === null || _p === void 0 ? void 0 : _p.length) {
                    formikContext.setFieldValue('deliveryOptions', response.deliveryOptions);
                    if (isFromBasketUpdate && isDateChange) {
                        const serviceDescription = (_q = response.deliveryOptions[0]) === null || _q === void 0 ? void 0 : _q.title;
                        serviceDescription && setSelectedDeliveryOption(serviceDescription);
                    }
                    setDeliveryOptions(response.deliveryOptions);
                    setPurchaseDateError('');
                }
                else {
                    setPurchaseDateError('');
                    setDeliveryOptions([]);
                    formikContext.setFieldValue('deliveryOptions', []);
                    setSuggesProducts(response.productSuggestions);
                    setIsProductUnavailableModalOpen(true);
                    setUnavailablePorductsCount(response.totalProductsCount);
                    saveToSessionStorage('clickAndCollect', 'false');
                }
                setIsSubmitting(false);
            }
            catch (error) {
                setIsSubmitting(false);
                return;
            }
        }
    });
    const handleSetSelectedDate = (date, isCalendarPicked) => {
        setDateSearchOpen(false);
        setIsChooseAnotherDate(false);
        setFromChooseDateOnUnavailModal(false);
        formikContext.setFieldValue('isCalendarPicked', isCalendarPicked);
        formikContext.setFieldValue('deliveryDate', date);
        formikContext.setFieldValue('selectedDeliveryOptionIndex', 0);
        isFromBasketUpdate && setIsDateChange(true);
        if (showProductAvailableCalendar && sendDateAnalytics) {
            sendDateAnalytics(date);
        }
        if ((isInternational || oldCalendar) && showProductAvailableCalendar) {
            setUnavailableModalOpen(false);
            setShowProductAvailableCalendar(false);
        }
    };
    const deliveryPassType = deliveryPassSku &&
        ((_c = (_b = (_a = digitalProducts === null || digitalProducts === void 0 ? void 0 : digitalProducts.find((product) => product.sku === deliveryPassSku)) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.split(' ')[1]) === null || _c === void 0 ? void 0 : _c.toUpperCase());
    const handleProductAvailabilityCallback = () => __awaiter(void 0, void 0, void 0, function* () {
        var _r;
        const today = new Date();
        const response = yield productAvailabilityCallback({
            startDate: formatDate(today, 'yyyy-MM-dd'),
            endDate: formatDate(lastDayOfMonth(addMonths(today, 4)), 'yyyy-MM-dd'),
            variant,
            address: formikAddress,
        });
        if (response.error) {
            setRequestError(`The product availability check returned an error response: ${response.error}`);
        }
        else {
            const productAvailability = (_r = response === null || response === void 0 ? void 0 : response.data) === null || _r === void 0 ? void 0 : _r.productAvailability;
            const validDeliveryDate = productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.some((availableDate) => availableDate.date === deliveryDate);
            if (productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.length) {
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('productAvailability', productAvailability);
            }
            if (!(productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.length) || !validDeliveryDate) {
                setUnavailableModalOpen(true);
                if (!(productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.length))
                    setNoProductAvalible(true);
            }
        }
    });
    const handleClickAndCollectAnalytics = () => {
        if (sessionStorage.getItem('clickAndCollect') === 'true') {
            sendClickAndCollectStatusAnalytics === null || sendClickAndCollectStatusAnalytics === void 0 ? void 0 : sendClickAndCollectStatusAnalytics('Click and collect available');
        }
        else {
            sendClickAndCollectStatusAnalytics === null || sendClickAndCollectStatusAnalytics === void 0 ? void 0 : sendClickAndCollectStatusAnalytics('Click and collect unavailable');
        }
    };
    const waitForDeliveryOptions = (shouldUseCurrentSelectedCCAddress) => __awaiter(void 0, void 0, void 0, function* () {
        const ruleIds = getRuleIds(deliveryDate);
        const address = isFlyingFlowers ? formikAddress : undefined;
        setUnavailableModalOpen(false);
        setFromChooseDateOnUnavailModal(false);
        setShowProductAvailableCalendar(false);
        sessionStorage.setItem('postCodeStorage', formikAddress.postalCode);
        if (!isEmpty(productAvailability)) {
            let showUnavailModal = false;
            setCcProductAvailabilityResponse([]);
            const validDeliveryDate = productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.some((availableDate) => availableDate.date === deliveryDate);
            if (validDeliveryDate) {
                const [deliveryOptions] = yield Promise.all([
                    handleDeliveryOptionsCall(deliveryDate, ruleIds, formikContext, false, deliveryPassType, address, undefined, selectedServiceDescription),
                    getCCProductAvailability(deliveryDate, country, formikAddress, shouldUseCurrentSelectedCCAddress), // Don't need to store the result
                ]);
                if (isEmpty(deliveryOptions))
                    showUnavailModal = true;
                handleClickAndCollectAnalytics();
            }
            else {
                showUnavailModal = true;
            }
            if (showUnavailModal && (isInternational || oldCalendar || isFromTributeUpdate)) {
                setUnavailableModalOpen(true);
            }
        }
        else if (isFromTributeUpdate) {
            setNoProductAvalible(true);
            setUnavailableModalOpen(true);
        }
    });
    useEffect(() => {
        const shouldFetchDeliveryOptions = deliveryDate &&
            !isEmpty(productAvailability) &&
            !fromChooseDateOnUnavailModal &&
            (!handleDeliveryOptionsOrAlternateProducts || showProductAvailableCalendar || isInternational || oldCalendar);
        const shouldFetchAlternateAndeliveryOptions = !!deliveryDate &&
            currentStep === step &&
            handleDeliveryOptionsOrAlternateProducts &&
            !isFuneral &&
            !showProductAvailableCalendar &&
            !isInternational &&
            !isChangeDeliveryDate &&
            !oldCalendar;
        const isSameStep = currentStep === step;
        const isFromNextStep = prevStepRef.current === currentStep + 1 && isSameStep;
        let isFromPreviousStepWithSameAddress = prevStepRef.current === currentStep - 1 && isSameStep && prevAddressRef.current === JSON.stringify(formikAddress);
        if (isSameStep && !isFromPreviousStepWithSameAddress) {
            prevAddressRef.current = JSON.stringify(formikAddress);
        }
        const shouldUseCurrentSelectedCCAddress = isFromNextStep || isFromPreviousStepWithSameAddress;
        const shouldFetchProductAvailability = currentStep === step && ((isFromBasketUpdate && (isInternational || oldCalendar)) || isFromTributeUpdate);
        const getDeliveryOptions = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (shouldFetchDeliveryOptions) {
                if (((_a = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values) === null || _a === void 0 ? void 0 : _a.addressLine1) && currentStep === step) {
                    yield waitForDeliveryOptions(shouldUseCurrentSelectedCCAddress);
                }
            }
            else if (shouldFetchAlternateAndeliveryOptions) {
                yield getDeliveryOptionsOrAlaternateProducts(shouldUseCurrentSelectedCCAddress);
            }
            else if (shouldFetchProductAvailability) {
                yield handleProductAvailabilityCallback();
            }
            prevStepRef.current = currentStep;
        });
        getDeliveryOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        deliveryDate,
        deliveryPassType,
        isFlyingFlowers,
        currentStep,
        isFromBasketUpdate,
        isFuneral,
        isInternational,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(productAvailability),
    ]);
    useEffect(() => {
        setDeliveryOptions(initialDeliveryOptions);
        formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryOptions', initialDeliveryOptions);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialDeliveryOptions]);
    useEffect(() => {
        var _a;
        setDeliveryOptions((_a = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values) === null || _a === void 0 ? void 0 : _a.deliveryOptions);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(((_d = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values) === null || _d === void 0 ? void 0 : _d.deliveryOptions) || [])]);
    const fetchClickAndCollectFlag = (selectedDeliveryOptionData) => {
        const isClickAndCollect = selectedDeliveryOptionIndex === 'collection';
        formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('isClickAndCollect', isClickAndCollect);
        const deliveryServiceCode = isClickAndCollect ? 'CSD' : selectedDeliveryOptionData === null || selectedDeliveryOptionData === void 0 ? void 0 : selectedDeliveryOptionData.serviceCode;
        return { isClickAndCollect, deliveryServiceCode };
    };
    const handleDeliveryOptionAnalytics = (serviceCode) => {
        if (sendDeliveryOptionAnalytics) {
            sendDeliveryOptionAnalytics(serviceCode || 'CSD');
        }
    };
    const handlePurchaseDateSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _s, _t;
        if (!deliveryDate) {
            setPurchaseDateError(DAYPICKER_ERROR_MESSAGE);
            return;
        }
        setIsSubmitting(true);
        const selectedDeliveryOptionData = deliveryOptions[selectedDeliveryOptionIndex];
        const { isClickAndCollect, deliveryServiceCode } = fetchClickAndCollectFlag(selectedDeliveryOptionData);
        const extraParams = productKey ? { productKey, variantKey: variant, occasion } : { variant };
        const response = yield isProductFulfillableCallback(Object.assign(Object.assign({}, extraParams), { deliveryDate,
            isClickAndCollect,
            deliveryServiceCode, isCourierUpgrade: isFlyingFlowers ? selectedDeliveryOptionData === null || selectedDeliveryOptionData === void 0 ? void 0 : selectedDeliveryOptionData.isCourierOption : undefined, address: formikAddress, funeralServiceTime: (_s = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values) === null || _s === void 0 ? void 0 : _s.funeralServiceTime, funeralServiceDate: (_t = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values) === null || _t === void 0 ? void 0 : _t.funeralServiceDate }));
        if (response.error) {
            setIsSubmitting(false);
            setRequestError(`The availability check returned an error response: ${response.error}`);
        }
        else if (!response.data || response.data.isProductFulfillable === false) {
            setIsSubmitting(false);
            if (isUpdateDate || !!productKey)
                setRequestError(`Product failed the availability check`);
            if (!productKey) {
                setUnavailableModalOpen(true);
            }
        }
        else {
            if (isClickAndCollect) {
                formikContext.setFieldValue('deliveryPassSku', ''); // Clear delivery pass sku if click and collect
                formikContext.setFieldValue('isClickAndCollect', isClickAndCollect);
                formikContext.setFieldValue('clickAndCollectOption', currentChosenCcDetails);
            }
            if (!isClickAndCollect) {
                formikContext.setFieldValue('deliveryOptionalRuleId', selectedDeliveryOptionData.optionalRuleId);
                formikContext.setFieldValue('deliveryStandardRuleId', selectedDeliveryOptionData.standardRuleId);
                /* On basket edit, deliveryOptionalRuleId and deliveryStandardRuleId are not being set in formikContext values
               so reading them from selected index */
                formikContext.setFieldValue('selectedDeliveryOptionIndex', selectedDeliveryOptionIndex);
            }
            formikContext.submitForm().finally(() => setIsSubmitting(false));
        }
    });
    const renderDeliveryOptions = (dateDetails) => {
        return dateDetails.map((option) => `${option.title} ${option.price.formatted}`);
    };
    const getDateDetails = (date) => __awaiter(void 0, void 0, void 0, function* () {
        const ruleIds = getRuleIds(date);
        const address = isFlyingFlowers ? formikAddress : undefined;
        return yield handleDeliveryOptionsCall(date, ruleIds, formikContext, true, undefined, address, true);
    });
    const changeAddress = () => {
        setUnavailableModalOpen(false);
        setIsProductUnavailableModalOpen(false);
        setIsChooseAnotherDate(false);
        setCurrentStep(step - 1);
        const offsetTop = stepRef.current ? stepRef.current.offsetTop - 300 : 0;
        window.scrollTo({ top: offsetTop });
    };
    const changeDeliveryDate = () => __awaiter(void 0, void 0, void 0, function* () {
        var _u, _v;
        isFromBasketUpdate && setIsChangeDeliveryDate(true);
        setUnavailableModalOpen(false);
        setFromChooseDateOnUnavailModal(true);
        formikContext.setFieldValue('deliveryDate', '');
        setIsProductUnavailableModalOpen(false);
        const today = new Date();
        const response = yield productAvailabilityCallback({
            startDate: formatDate(today, 'yyyy-MM-dd'),
            endDate: formatDate(lastDayOfMonth(addMonths(today, 4)), 'yyyy-MM-dd'),
            variant,
            address: formikAddress,
        });
        if (response.error) {
            setRequestError(`The product availability check returned an error response: ${response.error}`);
        }
        else {
            if ((_v = (_u = response === null || response === void 0 ? void 0 : response.data) === null || _u === void 0 ? void 0 : _u.productAvailability) === null || _v === void 0 ? void 0 : _v.length) {
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('productAvailability', response.data.productAvailability);
                setShowProductAvailableCalendar(true);
                setInitialFirstDate(response.data.productAvailability[0].date);
            }
            else {
                setUnavailableModalOpen(true);
                setNoProductAvalible(true);
            }
        }
    });
    const handleMonthChange = (endDate) => __awaiter(void 0, void 0, void 0, function* () {
        var _w, _x, _y;
        const convertedproductAvailabilityDate = convertDateFormat((_w = productAvailability[(productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.length) - 1]) === null || _w === void 0 ? void 0 : _w.date);
        const currentEndDate = convertedproductAvailabilityDate;
        const convertedEndDate = convertDateFormat(endDate);
        if (isBefore(convertedEndDate, currentEndDate) || isSameDay(convertedEndDate, currentEndDate)) {
            return;
        }
        formikContext.setFieldValue('calendarLoading', true);
        const startDate = addDays(currentEndDate, 1);
        const response = yield productAvailabilityCallback({
            startDate: format(startDate, 'yyyy-MM-dd'),
            endDate: format(convertedEndDate, 'yyyy-MM-dd'),
            variant,
            address: formikAddress,
        });
        if (response.error) {
            setRequestError(`The product availability check returned an error response: ${response === null || response === void 0 ? void 0 : response.error}`);
        }
        else {
            let existingAvailability = [];
            if (Array.isArray((_x = formikContext === null || formikContext === void 0 ? void 0 : formikContext.values) === null || _x === void 0 ? void 0 : _x.productAvailability)) {
                existingAvailability = formikContext.values.productAvailability;
            }
            else if (Array.isArray(initialProductAvailablity)) {
                existingAvailability = initialProductAvailablity;
            }
            const responseAvailability = Array.isArray((_y = response === null || response === void 0 ? void 0 : response.data) === null || _y === void 0 ? void 0 : _y.productAvailability)
                ? response.data.productAvailability
                : [];
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('productAvailability', [...existingAvailability, ...responseAvailability]);
        }
        formikContext.setFieldValue('calendarLoading', false);
    });
    const signIn = (values) => __awaiter(void 0, void 0, void 0, function* () {
        if (onSignIn) {
            yield onSignIn(values);
            setSignInModal(false);
        }
    });
    const hasFreeDeliveryService = deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.some((deliveryOption) => deliveryOption.standardDeliveryCharge === '0');
    useEffect(() => {
        var _a;
        if (purchaseDateError || (currentStep === step && stepRef)) {
            if (isTabletAndBelow) {
                const headerOffset = isIpad() ? 120 : 90;
                const offsetTop = stepRef.current ? stepRef.current.offsetTop - headerOffset : 0;
                if (offsetTop)
                    window.scrollTo({ top: offsetTop });
            }
            else {
                (_a = stepRef === null || stepRef === void 0 ? void 0 : stepRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'start', inline: 'start', behavior: 'smooth' });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep, step, isTabletAndBelow, purchaseDateError]);
    const viewAllAvailableGifts = () => {
        const qsObj = {
            date: deliveryDate !== null && deliveryDate !== void 0 ? deliveryDate : undefined,
            postalCode,
            city,
            county,
            addressLine2,
            occasion: occasion || formikOccasion,
            isSameDay: !!deliveryDate && isSameDay(new Date(deliveryDate), new Date()),
        };
        if (isFromBasketUpdate && handleBasketLineItem) {
            handleBasketLineItem(undefined, deliveryDate, qsObj);
            return;
        }
        setIsProductUnavailableModalOpen(false);
        router.push(`/search?${qs.stringify(qsObj, { encodeValuesOnly: true })}`);
    };
    useEffect(() => {
        if (isCalendarOpen)
            setIsProductUnavailableModalOpen(false);
    }, [isCalendarOpen]);
    useEffect(() => {
        setShowDeliveryInstruction(!!deliveryInstructionOption && deliveryInstructionOption !== 'Press to select'); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deliveryInstructionOption]);
    const purchaseDateStepTitle = isFlyingFlowers && !isDropship
        ? 'Choose a delivery date'
        : isDropship
            ? 'When would you like your gift to be delivered?'
            : 'When would you like your gift?';
    const stepContentWithEditIcon = currentStep > step ? (_jsxs("div", { className: classes.completed, children: [_jsx(TextField, { name: "deliveryDatePlaceholder", fullWidth: true, completed: true, onClick: () => {
                    setCurrentStep(step);
                    setIsSubmitting(false);
                }, children: selectedDeliveryOptionIndex === 'collection' && ccProductAvailabilityResponse ? (_jsx(CollectionDetails, { currentChosenCcDetails: currentChosenCcDetails, deliveryDate: deliveryDate, isTabletAndBelow: isTabletAndBelow, classes: classes })) : (_jsxs(_Fragment, { children: [_jsx("div", { children: format(convertDateFormat(deliveryDate), 'EEEE do MMMM yyy') }), !isFuneral && !isInternational && _jsx("div", { children: selectedDeliveryOption })] })) }), !isFlyingFlowers && deliveryInstructionNote && (_jsx(TextField, { name: "deliveryInstructionNote", fullWidth: true, completed: true, onClick: () => {
                    setCurrentStep(step);
                    setIsSubmitting(false);
                }, children: deliveryInstructionNote }))] })) : null;
    return (_jsxs("div", { ref: stepRef, children: [_jsxs(Box, { className: clsx(classes.heading, currentStep < step && classes.pending, isFromTributeUpdate ? classes.tributeUpdateCompleted : ''), children: [step, ". ", purchaseDateStepTitle] }), openSignInModal && (_jsx(Modal, { open: openSignInModal, setOpen: () => setSignInModal(false), fullScreen: isMobile, title: "Your Account", fullWidth: true, maxWidth: "md", children: _jsx(SignInModal, { onSignIn: signIn, saveUserJourneyAnalytics: saveUserJourneyAnalytics }) })), currentStep === step ? (_jsxs(_Fragment, { children: [(isFuneral && isFromBasketUpdate) || isInternational || showProductAvailableCalendar || oldCalendar ? (_jsx(ProductAvailabileDayPicker, { calendarLoading: !!formikContext.values.calendarLoading, handleMonthChange: handleMonthChange, days: productAvailability, selectedDate: deliveryDate, isCalendarPicked: isCalendarPicked, setSelectedDate: handleSetSelectedDate, renderSelectedDayDetails: renderDeliveryOptions, getDateDetails: getDateDetails, errorMessage: formikContext.errors.deliveryDate, isSaveOnClose: true, currentStep: currentStep, showProductAvailableCalendar: showProductAvailableCalendar, initialFirstDate: initialFirstDate, isFuneralBasket: isFuneral && isFromBasketUpdate, oldCalendar: oldCalendar })) : (_jsx(DayPicker, { calendarLoading: !!formikContext.values.calendarLoading, handleMonthChange: handleMonthChange, days: productAvailability, selectedDate: deliveryDate, isCalendarPicked: isCalendarPicked, setSelectedDate: handleSetSelectedDate, renderSelectedDayDetails: renderDeliveryOptions, getDateDetails: getDateDetails, errorMessage: purchaseDateError || formikContext.errors.deliveryDate, isSaveOnClose: true, currentStep: currentStep, isChooseAnotherDate: isChooseAnotherDate })), _jsxs(_Fragment, { children: [!isFlyingFlowers && !hasFreeDeliveryService && (_jsx(_Fragment, { children: !((_f = (_e = getCustomer === null || getCustomer === void 0 ? void 0 : getCustomer.data) === null || _e === void 0 ? void 0 : _e.customer) === null || _f === void 0 ? void 0 : _f.id) && (_jsx(DeliveryPassLoginPrompt, { onLoginClick: () => setSignInModal(true) })) })), !showDeliveryInstruction && !isFlyingFlowers && !isDropship && (_jsx("div", { className: classes.deliveryInstructionText, children: _jsx(Link, { className: classes.deliveryInstructionTextLink, label: DELIVERY_INSTRUCTION_LINK, onClick: () => setShowDeliveryInstruction(true) }) })), deliveryDate && !!(deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.length) && (_jsx(DeliveryOptions, { currentStep: currentStep, setCurrentStep: setCurrentStep, heading: `Select a delivery option for ${isValid(convertDateFormat(deliveryDate)) && format(convertDateFormat(deliveryDate), 'd MMM')}`, deliveryOptions: deliveryOptions, selectedServiceDescription: selectedServiceDescription, isUpdateDate: isUpdateDate, setDeliveryOption: setSelectedDeliveryOption, deliveryOptionsInfo: deliveryOptionsInfo, collectionData: ccProductAvailabilityResponse, currentChosenCcDetails: currentChosenCcDetails, setCurrentChosenCcDetails: setCurrentChosenCcDetails, deliveryDate: deliveryDate, handleDeliveryOptionAnalytics: handleDeliveryOptionAnalytics, sendClickAndCollectMapOrListViewAnalytics: sendClickAndCollectMapOrListViewAnalytics, sendClickAndCollectLoadMoreAnalytics: sendClickAndCollectLoadMoreAnalytics, sendClickAndCollectCloseModalAnalytics: sendClickAndCollectCloseModalAnalytics, sendClickAndCollectSelectFloristAnalytics: sendClickAndCollectSelectFloristAnalytics, sendClickAndCollectStartNewSearchAnalytics: sendClickAndCollectStartNewSearchAnalytics })), !((_j = (_h = (_g = getCustomer === null || getCustomer === void 0 ? void 0 : getCustomer.data) === null || _g === void 0 ? void 0 : _g.customer) === null || _h === void 0 ? void 0 : _h.deliveryPass) === null || _j === void 0 ? void 0 : _j.product) &&
                                digitalProducts &&
                                !hasActiveDeliveryPass &&
                                !!(deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.length) &&
                                !hasFreeDeliveryService &&
                                selectedDeliveryOptionIndex !== 'collection' && (_jsx(ChooseDeliveryPass, { deliveryPassOptions: digitalProducts, deliveryPassPromoText: (_k = deliveryOptions[selectedDeliveryOptionIndex]) === null || _k === void 0 ? void 0 : _k.deliveryPassPromotionText, deliveryPassPromotionType: (_l = deliveryOptions[selectedDeliveryOptionIndex]) === null || _l === void 0 ? void 0 : _l.deliveryPassPromotionType })), showDeliveryInstruction && !isFlyingFlowers && !isDropship && _jsx(DeliveryInstructions, {}), _jsx("div", { className: classes.next, children: productKey ? (_jsxs(_Fragment, { children: [_jsx(Button, { className: classes.saveButton, disabled: !(deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.length) || isSubmitting || !validDeliveryOption, variant: "primary", thin: true, fullWidth: true, title: isFromTributeUpdate ? 'Save changes' : 'Save delivery details', onClick: () => handlePurchaseDateSubmit() }), _jsx(Button, { variant: "tertiary", thin: true, fullWidth: true, title: "Cancel - discard changes", onClick: () => handleCancelChanges() })] })) : (_jsx(Button, { variant: "primary", disabled: isSubmitting, title: isFlyingFlowers ? 'Next: Personalise gift' : 'Next: Personalising your gift', thinOnMobile: true, fullWidth: true, onClick: () => handlePurchaseDateSubmit(), icon: isFlyingFlowers ? 'shopping_basket' : undefined })) }), !purchaseDateError && requestError && _jsx("span", { className: classes.error, children: requestError })] })] })) : (stepContentWithEditIcon), _jsx(GiftUnavailableModal, { open: isUnavailableModalOpen, setOpen: setUnavailableModalOpen, changeDeliveryDate: () => changeDeliveryDate(), changeAddress: () => changeAddress(), noProductAvalible: noProductAvalible, closeUnavailableModal: () => {
                    setShowProductAvailableCalendar(false);
                } }), isDateSearchOpen && (_jsx(DateSearchModal, { isOpen: isDateSearchOpen, setOpen: setDateSearchOpen, postalCode, city, county })), _jsx(DeliveryUnavailableModal, { open: isPorductsUnavailableModalOpen, setOpen: setIsProductUnavailableModalOpen, products: suggesProducts, productName: productName, changeDeliveryDate: () => changeDeliveryDate(), changeAddress: () => changeAddress(), viewAllAvailableGifts: viewAllAvailableGifts, handleOnClose: () => {
                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('isCalendarPicked', false);
                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue('deliveryDate', '');
                }, totalProductsCount: unavailableProductsCount, isFromBasketUpdate: isFromBasketUpdate, handleBasketLineItem: handleBasketLineItem, deliveryDate: deliveryDate })] }));
};
export default PurchaseDate;
